// extracted by mini-css-extract-plugin
export var logo = "FooterLogoSection-module--logo--c6a54";
export var logoSection = "FooterLogoSection-module--logoSection--6f25d";